import React from 'react';
import { Container, Row, Col } from 'reactstrap';

import badge1 from '../../../assets/images/gamification_badges/badge_1.png';
import badge2 from '../../../assets/images/gamification_badges/badge_2.png';
import badge3 from '../../../assets/images/gamification_badges/badge_3.png';
import badge4 from '../../../assets/images/gamification_badges/badge_4.png';
import badge5 from '../../../assets/images/gamification_badges/badge_5.png';
import badge6 from '../../../assets/images/gamification_badges/badge_6.png';

const GamificationSection = () => {
  return (
    <div style={{ backgroundColor: '#1a1d24', padding: '120px 0', position: 'relative', overflow: 'hidden' }}>

      {/* Background Decorativo Suave */}
      <div style={{
        position: 'absolute',
        top: '-20%',
        left: '-10%',
        width: '600px',
        height: '600px',
        background: 'radial-gradient(circle, rgba(0, 243, 255, 0.05) 0%, rgba(26,29,36,0) 70%)',
        zIndex: 0
      }}></div>

      {/* Background Decorativo Suave - Insignias Flutuantes */}
      <img src={badge1} alt="badge decorativo" className="position-absolute" style={{ width: '120px', top: '-8%', left: '-3%', transform: 'rotate(-15deg)', opacity: 0.15, filter: 'blur(3px)', zIndex: 0, pointerEvents: 'none' }} />
      <img src={badge2} alt="badge decorativo" className="position-absolute" style={{ width: '110px', bottom: '5%', right: '2%', transform: 'rotate(20deg)', opacity: 0.15, filter: 'blur(2px)', zIndex: 0, pointerEvents: 'none' }} />
      <img src={badge3} alt="badge decorativo" className="position-absolute" style={{ width: '140px', top: '15%', right: '12%', transform: 'rotate(45deg)', opacity: 0.2, filter: 'blur(4px)', zIndex: 0, pointerEvents: 'none' }} />
      <img src={badge4} alt="badge decorativo" className="position-absolute" style={{ width: '120px', bottom: '5%', left: '15%', transform: 'rotate(-10deg)', opacity: 0.15, filter: 'blur(3px)', zIndex: 0, pointerEvents: 'none' }} />
      <img src={badge5} alt="badge decorativo" className="position-absolute" style={{ width: '100px', top: '15%', left: '20%', transform: 'rotate(10deg)', opacity: 0.2, filter: 'blur(2px)', zIndex: 0, pointerEvents: 'none' }} />
      <img src={badge6} alt="badge decorativo" className="position-absolute" style={{ width: '150px', top: '40%', right: '25%', transform: 'rotate(-30deg)', opacity: 0.15, filter: 'blur(5px)', zIndex: 0, pointerEvents: 'none' }} />
      <img src={badge1} alt="badge decorativo" className="position-absolute" style={{ width: '130px', bottom: '30%', right: '15%', transform: 'rotate(5deg)', opacity: 0.2, filter: 'blur(2px)', zIndex: 0, pointerEvents: 'none' }} />

      <Container fluid className="px-4 px-xl-5 position-relative" style={{ zIndex: 1 }}>
        <Row className="align-items-center">
          
          {/* Esquerda: Textos e Títulos */}
          <Col lg={8} xl={6} className="position-relative mb-5 text-start">
            <div style={{ animation: 'fadeInLeft 1s ease-out', marginLeft: 'clamp(0px, 4vw, 60px)' }}>
              
              <div style={{ position: 'relative', marginBottom: '1.5rem' }}>
                <div 
                  className="position-absolute text-uppercase"
                  style={{
                    fontSize: 'clamp(4.5rem, 10vw, 11rem)', 
                    fontWeight: 'bold',
                    color: 'transparent',
                    WebkitTextStroke: '2px rgba(0, 243, 255, 0.1)', 
                    top: '50%',
                    left: '0', 
                    zIndex: -1,
                    pointerEvents: 'none',
                    userSelect: 'none',
                    letterSpacing: '8px',
                    whiteSpace: 'nowrap',
                    animation: 'floatingShadowGamification 8s ease-in-out infinite alternate', 
                    transform: 'translateY(-50%)'
                  }}
                >
                  GAMEFICAÇÃO
                </div>
                
                <h2 className="mb-0 text-uppercase position-relative" style={{ lineHeight: '1.2', zIndex: 1 }}>
                  <span className="d-block" style={{ fontSize: 'clamp(3rem, 6vw, 4.5rem)', fontWeight: 'bold', color: '#ffffff', textShadow: '0 2px 10px rgba(0,243,255,0.3)', letterSpacing: '-1px' }}>
                    GAMEFICAÇÃO
                  </span>
                </h2>
              </div>
              
              <div className="d-flex position-relative mt-4 mb-4" style={{ zIndex: 2 }}>
                <div 
                  style={{
                    width: '4px',
                    backgroundColor: '#00f3ff',
                    boxShadow: '0 0 10px #00f3ff, 0 0 20px rgba(0, 243, 255, 0.6)',
                    borderRadius: '2px',
                    marginRight: '20px',
                    flexShrink: 0
                  }}
                ></div>
                <div style={{ color: '#e9ecef', fontSize: 'clamp(1rem, 1.3vw, 1.3rem)', fontWeight: '300', maxWidth: '700px', lineHeight: '1.6' }}>
                  <strong style={{ color: '#fff' }}>Muito mais que Presença:</strong> Seu aluno ganha pontos
                  <span style={{ color: '#00f3ff', textShadow: '0 0 8px rgba(0,243,255,0.8)', margin: '0 8px', fontSize: '1.2em' }}>•</span>ao frequentar as aulas
                  <span style={{ color: '#00f3ff', textShadow: '0 0 8px rgba(0,243,255,0.8)', margin: '0 8px', fontSize: '1.2em' }}>•</span>ao renovar a matrícula
                  <span style={{ color: '#00f3ff', textShadow: '0 0 8px rgba(0,243,255,0.8)', margin: '0 8px', fontSize: '1.2em' }}>•</span>ao completar desafios
                  <span style={{ color: '#00f3ff', textShadow: '0 0 8px rgba(0,243,255,0.8)', margin: '0 8px', fontSize: '1.2em' }}>•</span>ao subir de nível técnico
                  <span style={{ color: '#00f3ff', textShadow: '0 0 8px rgba(0,243,255,0.8)', margin: '0 8px', fontSize: '1.2em' }}>•</span>e conquista insígnias exclusivas.<br/><br/>
                  Transforme a rotina em uma jornada altamente engajadora e construa a lealdade dos seus alunos!
                </div>
              </div>

              {/* Statistic Highlight */}
              <div 
                className="mt-3 d-inline-block position-relative" 
                style={{ 
                  backgroundColor: 'rgba(32, 38, 52, 0.65)', 
                  backdropFilter: 'blur(10px)',
                  border: '1px solid rgba(0, 243, 255, 0.2)',
                  borderRadius: '16px',
                  padding: '20px 25px',
                  boxShadow: '0 20px 40px rgba(0, 0, 0, 0.5)',
                  zIndex: 2
                }}
              >
                <div className="d-flex align-items-center">
                  <div style={{ width: '45px', height: '45px', borderRadius: '50%', backgroundColor: 'rgba(0, 243, 255, 0.15)', display: 'flex', alignItems: 'center', justifyContent: 'center', marginRight: '20px', flexShrink: 0 }}>
                    <i className="mdi mdi-trending-up" style={{ color: '#00f3ff', fontSize: '1.6rem', textShadow: '0 0 10px rgba(0,243,255,0.6)' }}></i>
                  </div>
                  <span style={{ color: '#a6b0cf', fontSize: '0.95rem', fontWeight: '500', lineHeight: '1.5', textAlign: 'left' }}>
                    Estudos apontam <strong style={{ color: '#00f3ff', fontSize: '1.05rem', textShadow: '0 0 5px rgba(0,243,255,0.3)' }}>aumento de até 40% na retenção</strong><br/>de alunos com sistemas de gamificação.
                  </span>
                </div>
              </div>

            </div>
          </Col>

          {/* Direita: Botão CTA */}
          <Col lg={4} xl={6} className="mt-4 mt-lg-0 d-flex justify-content-start justify-content-lg-end align-items-center align-items-lg-end mb-5" style={{ zIndex: 2, paddingRight: 'clamp(15px, 6vw, 100px)' }}>
            <div style={{ animation: 'fadeInRight 1s ease-out', marginLeft: 'clamp(0px, 4vw, 60px)' }} className="ms-lg-0">
              <a href="#fale-conosco" 
                 className="btn text-uppercase fw-bold text-center"
                 style={{
                   backgroundColor: 'transparent',
                   border: '2px solid #00f3ff',
                   color: '#00f3ff',
                   padding: '16px 36px',
                   fontSize: 'clamp(1rem, 2vw, 1.2rem)',
                   borderRadius: '12px',
                   letterSpacing: '1px',
                   whiteSpace: 'nowrap',
                   transition: 'all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)',
                   boxShadow: '0 8px 25px rgba(0, 243, 255, 0.2), inset 0 0 10px rgba(0, 243, 255, 0.05)',
                   textDecoration: 'none',
                   display: 'inline-block'
                 }}
                 onMouseOver={(e) => {
                   e.target.style.backgroundColor = 'rgba(0, 243, 255, 0.15)';
                   e.target.style.boxShadow = '0 15px 35px rgba(0, 243, 255, 0.5), inset 0 0 20px rgba(0, 243, 255, 0.3)';
                   e.target.style.transform = 'translateY(-5px) scale(1.05)';
                 }}
                 onMouseOut={(e) => {
                   e.target.style.backgroundColor = 'transparent';
                   e.target.style.boxShadow = '0 8px 25px rgba(0, 243, 255, 0.2), inset 0 0 10px rgba(0, 243, 255, 0.05)';
                   e.target.style.transform = 'translateY(0) scale(1)';
                 }}
              >
                FALE CONOSCO
              </a>
            </div>
          </Col>
        </Row>
      </Container>

      <style>
        {`
          @keyframes popBadge {
            0% { transform: scale(0.5) translateY(50px); opacity: 0; }
            100% { transform: scale(1) translateY(0); opacity: 1; }
          }
          @keyframes floatingShadowGamification {
            from { transform: translateY(-50%) translateX(0px); }
            to { transform: translateY(-50%) translateX(-15px); }
          }
          @keyframes fadeInLeft {
            from { transform: translateX(-40px); opacity: 0; }
            to { transform: translateX(0); opacity: 1; }
          }
          @keyframes fadeInRight {
            from { transform: translateX(40px); opacity: 0; }
            to { transform: translateX(0); opacity: 1; }
          }
        `}
      </style>
    </div>
  );
};

export default GamificationSection;
